import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-primary-500 py-16" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4" }
const _hoisted_4 = { class: "text-5xl lg:text-[60px] font-extrabold text-white leading-none mb-2" }
const _hoisted_5 = { class: "text-primary-100 text-sm font-medium uppercase tracking-wide" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats, (stat, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: stat.label,
            class: _normalizeClass(["text-center", index < _ctx.stats.length - 1 ? 'lg:border-r lg:border-primary-400' : ''])
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(stat.value), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(stat.label), 1)
          ], 2))
        }), 128))
      ])
    ])
  ]))
}